/**
 * 项目管理导航树 Mock 数据
 */
import type { NavTreeNode } from '@/types/common';
import { ROUTE_PATHS } from '@/utils/constants';

/** 项目管理导航树 */
export const projectsNavTree: NavTreeNode[] = [
  {
    id: 'project-registration',
    label: '项目报备',
    icon: 'assignment',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'new-registration',
        label: '新建报备',
        icon: 'assignment',
        route: ROUTE_PATHS.PROJECTS_NEW_REGISTRATION,
      },
      {
        id: 'registration-list',
        label: '报备列表',
        icon: 'assignment',
        route: ROUTE_PATHS.PROJECTS_REGISTRATION_LIST,
      },
    ],
  },
  {
    id: 'opportunity-management',
    label: '机会管理',
    icon: 'lightbulb',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'opportunities',
        label: '查机会点',
        icon: 'lightbulb',
        route: ROUTE_PATHS.PROJECTS_OPPORTUNITIES,
      },
      {
        id: 'opportunity-analysis',
        label: '接手机会',
        icon: 'lightbulb',
        route: ROUTE_PATHS.PROJECTS_OPPORTUNITY_ANALYSIS,
      },
      {
        id: 'opportunity-recommendation',
        label: '机会推荐',
        icon: 'lightbulb',
        route: ROUTE_PATHS.PROJECTS_OPPORTUNITY_RECOMMENDATION,
      },
    ],
  },
  {
    id: 'business-application',
    label: '商务申请',
    icon: 'request_quote',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'special-pricing',
        label: '特价申请',
        icon: 'request_quote',
        route: ROUTE_PATHS.PROJECTS_SPECIAL_PRICING,
      },
      {
        id: 'rebate-application',
        label: '返点申请',
        icon: 'request_quote',
        route: ROUTE_PATHS.PROJECTS_REBATE_APPLICATION,
      },
      {
        id: 'contract-application',
        label: '合同申请',
        icon: 'request_quote',
        route: ROUTE_PATHS.PROJECTS_CONTRACT_APPLICATION,
      },
    ],
  },
  {
    id: 'letter-material',
    label: '函件与资料',
    icon: 'description',
    route: '',
    defaultExpanded: true,
    children: [
      {
        id: 'authorization-letter',
        label: '授权函申请',
        icon: 'description',
        route: ROUTE_PATHS.PROJECTS_AUTHORIZATION_LETTER,
      },
      {
        id: 'commitment-letter',
        label: '承诺函申请',
        icon: 'description',
        route: ROUTE_PATHS.PROJECTS_COMMITMENT_LETTER,
      },
      {
        id: 'material-request',
        label: '资料申请',
        icon: 'description',
        route: ROUTE_PATHS.PROJECTS_MATERIAL_REQUEST,
      },
    ],
  },
];
